var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { FxAgGridValidationEditorComponent } from './fx-ag-grid-validation-editor';
var FxAgCheckboxRendererComponent = /** @class */ (function (_super) {
    __extends(FxAgCheckboxRendererComponent, _super);
    function FxAgCheckboxRendererComponent(fb) {
        var _this = _super.call(this) || this;
        _this.fb = fb;
        _this.checked = false;
        _this.disabled = false;
        _this.dwTrueVal = 'Y';
        _this.dwFalseVal = 'N';
        return _this;
    }
    FxAgCheckboxRendererComponent.prototype.agInit = function (params) {
        this.params = params;
        if (this.params.colDef.cellRendererParams &&
            this.params.colDef.cellRendererParams.dwTrueVal) {
            this.dwTrueVal = this.params.colDef.cellRendererParams.dwTrueVal;
        }
        if (this.params.colDef.cellRendererParams &&
            this.params.colDef.cellRendererParams.dwFalseVal) {
            this.dwFalseVal = this.params.colDef.cellRendererParams.dwFalseVal;
        }
        if (this.params.getValue() === this.dwTrueVal) {
            this.checked = true;
        }
        else if (this.params.getValue() === this.dwFalseVal) {
            this.checked = false;
        }
        else {
            // console.log('Value is Error!');
        }
        if (this.params.colDef.cellRendererParams &&
            this.params.colDef.cellRendererParams.dwDisabled) {
            this.disabled = this.params.colDef.cellRendererParams.dwDisabled;
        }
        this.formControl = new FormControl(this, params.validators);
        this.validateForm = params.form;
        if (!params.form) {
            this.validateForm = this.fb.group({});
        }
        this.name = this.params.node.id + '-' + params.column.colId;
        if (this.validateForm.contains(this.name)) {
            this.validateForm.setControl(this.name, this.formControl);
        }
        else {
            this.validateForm.addControl(this.name, this.formControl);
        }
        this.formControl.markAsDirty();
        _super.prototype.init.call(this);
    };
    FxAgCheckboxRendererComponent.prototype.refresh = function () {
        return false;
    };
    FxAgCheckboxRendererComponent.prototype.ngOnDestroy = function () {
        this.validateForm.removeControl(this.name);
    };
    return FxAgCheckboxRendererComponent;
}(FxAgGridValidationEditorComponent));
export { FxAgCheckboxRendererComponent };
